import { Link, useParams } from "react-router"

import { Button } from "@repo/ui"
import { ArrowLeft } from "@phosphor-icons/react"
import { memo } from "react"
import { FinancialTablesLink } from "@/feature/financial-model/components/FinancialTablesLink"

export const EcommerceCommonHeader = memo(
  (props: {
    linkText: string
    path: string
    hideFinancialTablesLink?: boolean
  }) => {
    const { id } = useParams<{ id: string }>()
    return (
      <div className="flex items-center justify-between w-full">
        <Button size="md" asChild variant="link">
          <Link to={props.path}>
            <ArrowLeft size={16} className="mr-2" weight="bold" />
            {props.linkText}
          </Link>
        </Button>
        {!props.hideFinancialTablesLink && (
          <FinancialTablesLink financialModelId={id!} />
        )}
      </div>
    )
  }
)
